// extracted by mini-css-extract-plugin
export default {"body":"Layout_body__tK2jF","main":"Layout_main__FxQfo"};